<mat-toolbar>
    <span>Agregar Entregable</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="mr-5 p-5 bg-white w-full">
    <form [formGroup]="formEntregable">
        <div class="flex p-5 pb-0">
            <mat-form-field class="w-1/3 mr-5">
                <mat-label>Tipo de Entregable</mat-label>
                <mat-select formControlName="tipo">
                    @for (item of catEntregable; track item.id) {
                        @if(item.activo) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                    <mat-option value="otro">Otro</mat-option>
                </mat-select>
                @if(formEntregable.controls["tipo"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            @if(formEntregable.get('tipo')?.value == 'otro') {
                <mat-form-field class="w-2/3 mr-5">
                    <mat-label>Escribe aquí el tipo de Entregable</mat-label>
                    <input type="text" matInput formControlName="tipo_descripcion" #tipo_descripcion maxlength="100">
                    <mat-hint align="end">{{tipo_descripcion.value.length}} / 100</mat-hint>
                    @if(formEntregable.controls["tipo_descripcion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            }
            <span style="flex: 1 1 auto;"></span>
            <div class="mr-5">
                <a mat-fab color="primary" [disabled]="
                    formEntregable.get('tipo')?.value == '' ||
                    (
                        formEntregable.get('tipo')?.value == 'otro' 
                        &&
                        formEntregable.get('tipo_descripcion')?.value == ''
                    )
                " (click)="guardaEntregable()"><mat-icon>add</mat-icon></a>
            </div>
        </div>
        <div class="flex p-5 pb-0">
        </div>
    </form>

    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    
    @for (item of listaEntregables; track item; let index = $index) {
        <mat-card appearance="outlined" class="mb-5" [class.entregable-estado-incorrecto]="!(item.estatus_descripcion == estadosEntregable.estados[item.estatus])">
            <mat-card-header>
                <div mat-card-avatar class="mat-card-header-icon">
                    <mat-icon style="color:#3f51b5">book</mat-icon>
                </div>
                <div class="flex w-full items-baseline">
                    <mat-card-title class="flex-1">{{item.tipo_descripcion}}</mat-card-title>
                    <mat-card-subtitle>{{item.estatus_descripcion}}</mat-card-subtitle>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="item.tipo != 'adjuntar'">
                    @if(!ocultaSeccion(item)) {
                        <div class="flex flex-row">
                            <mat-form-field class="flex-auto mr-5">
                                <mat-label>Genere un documento y escriba aquí el código de verificación</mat-label>
                                <input matInput [value]="item.idGas" (keyup)="validaChangeDocumento($event, item)" [disabled]="item.used" minlength="20" maxlength="20" required>
                            </mat-form-field>
                            <div>
                                <button *ngIf="!item.used && item.nuevo" (click)="generarDocumento()" mat-stroked-button color="primary mt-2">GENERAR DOCUMENTO</button>
                                <button *ngIf="item.used" (click)="abrirDocumento(item)" [disabled]="!item.edicion_usuario" mat-stroked-button color="primary mt-2">ABRIR DOCUMENTO</button>
                            </div>
                        </div>
                        <div class="flex flex-row" *ngIf="item.used">
                            <mat-form-field class="w-full mr-5">
                                <mat-label>Título de entregable</mat-label>
                                <input matInput [value]="item.title" [disabled]="item.used">
                            </mat-form-field>
                        </div>
                    } 
                </div>
                <mat-form-field class="w-full">
                    <mat-label>Comentarios</mat-label>
                    <textarea matInput [(ngModel)]="item.comentarios" [disabled]="!(item.edicion)" maxlength="1000"></textarea>
                    <mat-hint align="end">{{item.comentarios.length}} / 1000</mat-hint>
                </mat-form-field>
                <div class="flex flex-row">
                    <div class="w-1/2">
                        <div class="flex p-5 pl-0">
                            <mat-icon>attach_file</mat-icon>Agregar Archivos
                        </div>
                        <div class="flex flex-col">
                            @for (itemFile of item.archivos; track itemFile; let indexArchivo = $index) {
                                <div class="flex justify-start items-center pb-2">
                                    <a mat-mini-fab color="primary" href="{{itemFile.url}}" target="_blank" disabled="{{itemFile.url?false:true}}">
                                        <mat-icon>remove_red_eye</mat-icon>
                                    </a>
                                    <button mat-mini-fab color="warn" class="ml-2 mr-2" (click)="eliminarArchivos(indexArchivo, item)" [disabled]="!(item.edicion)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <span>{{ itemFile.name }} <b class="text-xs">{{itemFile.code}}</b></span>
                                </div>
                            }
                        </div>
                        <div class="flex p-5 pb-0 pl-0 flex-row">
                            <button mat-stroked-button color="primary" (click)="inputFile.click()" [disabled]="!(item.edicion)">AGREGAR ARCHIVO</button>
                            <input #inputFile type="file" multiple="false" (change)="selectFile(index, item, $event)" class="hidden"/>
                        </div>
                    </div>
                    <div class="w-1/2">
                        <mat-form-field class="w-full">
                            <mat-label>Seleccione una acción</mat-label>
                            <mat-select [(value)]="item.accion" [disabled]="!(item.edicion)" required="required">
                                <mat-option *ngIf="item.nuevo" value="0">Eliminar</mat-option>
                                <mat-option *ngIf="(item.nuevo && item.estatus == 1 && oEntrada.analista != oUsuario.uid && oEntrada.edicion)" value="10">Confirmar Entregable</mat-option>
                                <mat-option *ngIf="(item.nuevo && item.estatus == 1 && oEntrada.analista == oUsuario.uid && oEntrada.edicion && deshabilitado)" value="10">Guardar entregable</mat-option>
                                @for (itemCat of estadosEntregable.catalogo; track itemCat) {
                                    @if(itemCat.estatus == item.estatus) {
                                        <mat-option *ngIf="!item.nuevo" [value]="itemCat.id">{{itemCat.descripcion}}</mat-option>
                                    }
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="control hidden">
                            Nuevo: {{item.nuevo | json}}<br>
                            Estatus: {{item.estatus}}<br>
                            Edicion: {{item.edicion}}<br>
                            Edicion Entrada: {{oEntrada.edicion}}<br>
                            Deshabilitado Entrada: {{oEntrada.desabilitado | json}}<br>
                            Deshabilitado: {{this.deshabilitado | json}}
                        </div>
                    </div>
                </div>
                <div class="flex justify-end">
                    <button mat-flat-button color="primary" (click)="accionEntregable(item.accion, index, item)" [disabled]="!item.edicion || !(item.accion != null)">ACEPTAR</button>
                </div>
            </mat-card-content>
        </mat-card>
    }

    <div>
        @if(bitacora){
            <button mat-stroked-button color="primary" (click)="bitacoraEntregables()">DESCARGAR BITACORA</button>
        }
    </div>
</div>


<!-- @if(index == globaIndex) {
    <div class="absolute w-full h-full rounded-md top-0 right-0 z-50 flex flex-col justify-start items-baseline bg-white shadow">
        @for (item of processObservable(); track item) {
            <div class="w-full p-5">
                <img src="./../../../assets/images/upload.gif" class="w-5 h-5" />
                <span>{{item.progress}} %</span> - <span>{{item.name}}</span> - <span>{{item.status}}</span><br />
                <mat-progress-bar mode="determinate" [value]="item.progress"></mat-progress-bar>
            </div>
        }
    </div>
} -->